"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Table = _interopRequireDefault(require("../appComponents/Table"));
var _Button = _interopRequireDefault(require("../baseComponents/Button"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ExpandingTable = /*#__PURE__*/function (_Component) {
  function ExpandingTable(props) {
    var _this;
    _classCallCheck(this, ExpandingTable);
    _this = _callSuper(this, ExpandingTable, [props]);
    _this.state = {
      rowsState: props.tableContent.map(function (row) {
        return row[0].hidden;
      })
    };
    _this.refsArray = _toConsumableArray(Array(props.tableContent.length)).map(function () {
      return /*#__PURE__*/_react["default"].createRef();
    });
    _this.showHide = _this.showHide.bind(_this);
    _this.onCancel = _this.onCancel.bind(_this);
    _this.onSave = _this.onSave.bind(_this);
    return _this;
  }
  _inherits(ExpandingTable, _Component);
  return _createClass(ExpandingTable, [{
    key: "showHide",
    value: function showHide(rowInformation, index) {
      var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (show && this.state.rowsState[index] || !show && !this.state.rowsState[index]) return;
      if (show && this.props.shouldRowOpen && !this.props.shouldRowOpen()) {
        return;
      }
      var newRowsState = this.state.rowsState;
      newRowsState[index] = show;
      // calling a callback after showing the hidden content
      setTimeout(function () {
        return rowInformation[1].onExpand && show && rowInformation[1].onExpand();
      });
      this.setState({
        rowsState: newRowsState
      });
    }
  }, {
    key: "onCancel",
    value: function onCancel(e, rowInformation, index, callback) {
      this.showHide(rowInformation, index, false);
      var cancelBtn = rowInformation[1].cancelBtn ? rowInformation[1].cancelBtn : {};
      if (cancelBtn.onClick) {
        cancelBtn.onClick(e, rowInformation, index);
      } else if (this.props.defaultCancelBtn.onClick) {
        this.props.defaultCancelBtn.onClick(e, rowInformation, index);
      }
    }
  }, {
    key: "onSave",
    value: function onSave(e, rowInformation, index, callback, btnRef) {
      var saveBtn = rowInformation[1].saveBtn ? rowInformation[1].saveBtn : {};
      if (saveBtn.closeOnSave === true || saveBtn.closeOnSave == null && this.props.defaultCloseOnSave) {
        this.showHide(rowInformation, index, false);
      }
      if (saveBtn.onClick) {
        saveBtn.onClick(e, rowInformation, index, btnRef);
      } else if (this.props.defaultSaveBtn.onClick) {
        this.props.defaultSaveBtn.onClick(e, rowInformation, index, btnRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var content = this.props.tableContent.map(function (row, rowIndex) {
        var cols = [];
        var isHidden = _this2.state.rowsState[rowIndex];
        var rowIsDisabled = row[0].disabled;
        var hasHiddenContent = row[0].hiddenContent || row[1].hiddenContent;
        var infoClasses = (0, _classnames["default"])("infoContainer", "row" + rowIndex, _this2.props.expandableClickArea, {
          hidden: isHidden,
          noHiddenContent: !hasHiddenContent
        });
        var hiddenContentClass = (0, _classnames["default"])("editInfoContainer", "row" + rowIndex, _this2.props.expandableClickArea, {
          hidden: !isHidden,
          noHiddenContent: !hasHiddenContent
        });
        var columnClass = (0, _classnames["default"])("column", {
          disabled: rowIsDisabled
        });
        var iconName = _this2.props.iconName;
        var iconType = _this2.props.iconType;
        if (rowIsDisabled) {
          iconName = _this2.props.disabledIconName;
          iconType = _this2.props.disabledIconType;
        }
        if (row[0]) {
          var isClickArea = ["left", "both"].indexOf(_this2.props.expandableClickArea) > -1;
          var isExpandableArea = isClickArea && hasHiddenContent;
          cols.push(/*#__PURE__*/_react["default"].createElement("div", {
            className: columnClass
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: infoClasses,
            onClick: isExpandableArea ? function () {
              _this2.showHide(row, rowIndex, true);
            } : function () {}
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[0].title && /*#__PURE__*/_react["default"].createElement("h6", null, row[0].title), row[0].text && /*#__PURE__*/_react["default"].createElement("p", {
            className: "narrow"
          }, row[0].text)), (_this2.props.showHoverIcon && isExpandableArea || rowIsDisabled && isClickArea) && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
            name: iconName,
            type: iconType
          })), row[0].hiddenContent && /*#__PURE__*/_react["default"].createElement("div", {
            className: hiddenContentClass
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[0].hiddenContent))));
        }
        if (row[1]) {
          var _isClickArea = ["right", "both"].indexOf(_this2.props.expandableClickArea) > -1;
          var _isExpandableArea = _isClickArea && hasHiddenContent;
          var cancelBtn = row[1].cancelBtn ? row[1].cancelBtn : {};
          var saveBtn = row[1].saveBtn ? row[1].saveBtn : {};
          cancelBtn = {
            onClick: cancelBtn.onClick ? cancelBtn.onClick : _this2.props.defaultCancelBtn.onClick,
            text: cancelBtn.text ? cancelBtn.text : _this2.props.defaultCancelBtn.text
          };
          saveBtn = {
            onClick: saveBtn.onClick ? saveBtn.onClick : _this2.props.defaultSaveBtn.onClick,
            text: saveBtn.text ? saveBtn.text : _this2.props.defaultSaveBtn.text,
            animated: saveBtn.hasOwnProperty("animated") ? saveBtn.animated : _this2.props.defaultSaveBtn.animated,
            animateOnClick: saveBtn.hasOwnProperty("animateOnClick") ? saveBtn.animateOnClick : _this2.props.defaultSaveBtn.animateOnClick,
            loadingText: saveBtn.loadingText ? saveBtn.loadingText : _this2.props.defaultSaveBtn.loadingText,
            doneText: saveBtn.doneText ? saveBtn.doneText : _this2.props.defaultSaveBtn.doneText,
            disabled: saveBtn.hasOwnProperty("disabled") ? saveBtn.disabled : _this2.props.defaultSaveBtn.disabled,
            closeOnSave: saveBtn.hasOwnProperty("closeOnSave") ? saveBtn.closeOnSave : _this2.props.defaultSaveBtn.closeOnSave
          };
          cols.push(/*#__PURE__*/_react["default"].createElement("div", {
            className: columnClass
          }, row[1].information && /*#__PURE__*/_react["default"].createElement("div", {
            className: infoClasses,
            onClick: _isExpandableArea ? function () {
              _this2.showHide(row, rowIndex, true);
            } : function () {}
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[1].information), (_this2.props.showHoverIcon && _isExpandableArea || rowIsDisabled && _isClickArea) && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
            name: iconName,
            type: iconType
          })), row[1].hiddenContent && /*#__PURE__*/_react["default"].createElement("div", {
            className: hiddenContentClass
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[1].hiddenContent, /*#__PURE__*/_react["default"].createElement("div", {
            className: "buttons"
          }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            colorTheme: "grey",
            size: "small",
            tabIndex: 1,
            type: "submit",
            onClick: function onClick(e) {
              _this2.onCancel(e, row, rowIndex, cancelBtn.onClick);
            },
            shapeStyle: "stroke",
            radius: "square"
          }, cancelBtn.text), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            onClick: function onClick(e) {
              _this2.onSave(e, row, rowIndex, saveBtn.onClick, _this2.refsArray[rowIndex]);
            },
            text: saveBtn.text,
            tabIndex: 2,
            ref: function ref(_ref) {
              _this2.refsArray[rowIndex] = _ref;
            },
            animated: saveBtn.animated,
            animateOnClick: saveBtn.animateOnClick,
            loadingText: saveBtn.loadingText,
            doneText: saveBtn.doneText,
            disabled: saveBtn.disabled,
            radius: "square",
            colorTheme: "teal",
            shapeStyle: "fill",
            size: "small"
          }))))));
        }
        return cols;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "expending-table-component"
      }, /*#__PURE__*/_react["default"].createElement(_Table["default"], {
        disabled: this.props.disabled,
        style: this.props.style,
        className: this.props.className,
        textAlign: this.props.textAlign,
        tableContent: content
      }));
    }
  }]);
}(_react.Component);
;
ExpandingTable.propTypes = {
  tableContent: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]),
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]),
    hiddenContent: _propTypes["default"].any,
    hidden: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    onExpand: _propTypes["default"].func
  }), _propTypes["default"].shape({
    information: _propTypes["default"].any,
    hiddenContent: _propTypes["default"].any,
    cancelBtn: _propTypes["default"].shape({
      onClick: _propTypes["default"].func,
      text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
    }),
    saveBtn: _propTypes["default"].shape({
      onClick: _propTypes["default"].func,
      text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
      animated: _propTypes["default"].bool,
      animateOnClick: _propTypes["default"].bool,
      loadingText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
      doneText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
      disabled: _propTypes["default"].bool,
      closeOnSave: _propTypes["default"].bool
    })
  }))),
  defaultCloseOnSave: _propTypes["default"].bool,
  defaultCancelBtn: _propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  }),
  defaultSaveBtn: _propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    animated: _propTypes["default"].bool,
    animateOnClick: _propTypes["default"].bool,
    loadingText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    doneText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    disabled: _propTypes["default"].bool,
    closeOnSave: _propTypes["default"].bool
  }),
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  textAlign: _propTypes["default"].oneOf(["", "text-align-left", "text-align-right"]),
  expandableClickArea: _propTypes["default"].oneOf(["left", "right", "both"]),
  showHoverIcon: _propTypes["default"].bool,
  iconName: _propTypes["default"].string,
  iconType: _propTypes["default"].string,
  disabledIconName: _propTypes["default"].string,
  disabledIconType: _propTypes["default"].string,
  shouldRowOpen: _propTypes["default"].func
};
ExpandingTable.defaultProps = {
  tableContent: [],
  defaultCloseOnSave: false,
  defaultCancelBtn: {
    onClick: null,
    text: ""
  },
  defaultSaveBtn: {
    onClick: null,
    text: null,
    animated: true,
    animateOnClick: true,
    loadingText: null,
    doneText: null,
    disabled: false,
    closeOnSave: false
  },
  disabled: false,
  className: "",
  style: {},
  textAlign: "text-align-left",
  expandableClickArea: "left",
  showHoverIcon: false,
  iconName: "glyph-edit",
  iconType: "glyph",
  disabledIconName: "glyph-lock",
  disabledIconType: "glyph",
  shouldRowOpen: null
};
var _default = exports["default"] = ExpandingTable;